import { inputTypes } from "client/services/form-service/form-inputs";
import { FORM_FIELD_LABELS, HUBSPOT_FIELD_LABELS } from "client/services/form-service/form-translation-keys";
export const INPUT_TYPE_TO_HUBSPOT_FIELD_TYPE_MAP = {
    text: inputTypes.TEXT,
    singleline: inputTypes.TEXT,
    email: inputTypes.EMAIL,
    textarea: inputTypes.TEXT_AREA,
    phonenumber: inputTypes.PHONE,
    select: inputTypes.MULTI_SELECT,
    radio: inputTypes.MULTI_SELECT,
    booleancheckbox: inputTypes.CHECKBOX
};
// Post-submission action types
export const ACTION_TYPES = {
    REDIRECT: "redirect",
    DOWNLOAD: "download",
    MESSAGE: "message"
};
export const FIELD_LABEL_MAP = {
    "label-firstname": FORM_FIELD_LABELS.REQUIRED_FIRST_NAME,
    "label-lastname": FORM_FIELD_LABELS.REQUIRED_LAST_NAME,
    "label-email": FORM_FIELD_LABELS.REQUIRED_WORK_EMAIL,
    "label-jobtitle": HUBSPOT_FIELD_LABELS.JOB_TITLE,
    "label-event___job_title": HUBSPOT_FIELD_LABELS.JOB_TITLE,
    "label-phone": FORM_FIELD_LABELS.REQUIRED_PHONE_NUMBER,
    "label-company": HUBSPOT_FIELD_LABELS.REQUIRED_COMPANY_NAME,
    "label-company_size__c": FORM_FIELD_LABELS.REQUIRED_COMPANY_SIZE,
    "label-product_question_hs_forms": HUBSPOT_FIELD_LABELS.PRODUCT_QUESTION,
    "label-how_can_our_consulting_team_help_you": HUBSPOT_FIELD_LABELS.HOW_CAN_HELP_TITLE,
    "label-country_picklist": HUBSPOT_FIELD_LABELS.COUNTRY
};
